import styled from 'styled-components';
import { Radio } from 'antd';

const CustomRadioStyle = styled(Radio)(
  ({ width, height, tHeight, dHeight, responsiveWidth, responsiveHeight, responsiveTHeight, responsiveDHeight }) => ` 
  margin: 1.75rem 0.75rem 1.75rem 0.75rem;
  .ant-radio{
    display: none;
  }
  
    span:nth-child(2){
      width: ${width || '320px'};
      height: ${height || '149px'};
      padding: 0;
      justify-content: space-between;

      .custom-radio-style-card-title {
        display: flex;
        width: 100%;
        height: ${tHeight || '73px'};
        align-items: center;
        padding: 10px 15px 0px 15px;
        color: #172458;
        font-family: 'UbuntuMedium';
        font-size: 16px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.2;
      }

      .custom-radio-style-card-description {
        display: flex;
        width: 100%;
        height: ${dHeight || '76px'};
        padding: 10px 15px 0px 15px;
        margin: 0;
        background: #f2f5f7;
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;
        color: #515c6c;
        font-family: 'UbuntuRegular';
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.2;
      }
    }

  @media (max-width: 1199.98px){
    span:nth-child(2){
      width: ${responsiveWidth || '148px'} !important;
      height: ${responsiveHeight || '172px'} !important;

      .custom-radio-style-card-title {
        height: ${responsiveTHeight || '57px'} !important;
        font-size: 14px !important;
      }

      .custom-radio-style-card-description {
        height: ${responsiveDHeight || '119px'};
        font-size: 12px !important;
      }
    } 
  }`,
);

export const CustomRadio = ({ title, description, width, height, tHeight, dHeight, responsiveWidth, responsiveHeight, responsiveTHeight, responsiveDHeight, ...props }) => {
  return (
    <CustomRadioStyle
      {...props}
      className="custom-radio-style"
      width={width}
      height={height}
      tHeight={tHeight}
      dHeight={dHeight}
      responsiveWidth={responsiveWidth}
      responsiveHeight={responsiveHeight}
      responsiveTHeight={responsiveTHeight}
      responsiveDHeight={responsiveDHeight}
    >
      <div className="custom-radio-style-card-title">{title}</div>
      <p className="custom-radio-style-card-description">{description}</p>
    </CustomRadioStyle>
  );
};

const CustomRadioGroupStyle = styled(Radio.Group)(
  () => `
  .ant-radio-wrapper-checked{
    border-radius: 10px !important;
    box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.11) !important;
    border: solid 2px #00a483 !important;
    background-color: #fff !important;
  }

  .ant-radio-wrapper{
    border-radius: 10px;
    border-width: 2px;
    box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.11);
    background-color: #fff;
  }

  @media (max-width: 1199.98px){
    display: flex !important;

    .ant-radio-wrapper-checked{
      .custom-radio-style-card-description {
        height: 115px !important;
        font-size: 12px !important;
      }
    }
  }
`,
);

export const CustomRadioGroup = ({ children, ...props }) => {
  return (
    <CustomRadioGroupStyle {...props} className="custom-radio-group-style">
      {children}
    </CustomRadioGroupStyle>
  );
};
